import { getAssetCommandItems } from '../commandBarItems/board/getAssetCommandItems';
import { getClearSelectionMenuItem } from '../commandBarItems/board/getClearSelectionMenuItem';
import { getCreateAssetMenuItem } from '../commandBarItems/board/getCreateAssetMenuItem';
import { getGoToTodayMenuItem } from '../commandBarItems/getGoToTodayMenuItem';
import { getViewSwitcherMenuItem } from '../commandBarItems/getViewSwitcherMenuItem';
import { CalendarModuleCommandBarConfig } from '../schema';
import { lazyGetSelectedAssets } from 'owa-calendar-board';
import { ASSET_REGISTRY } from 'owa-calendar-board-assets';

export function getBoardCommandBarConfig(
    onCustomRenderSubMenuChange: () => void,
    isShowAllAssetsExpanded: boolean,
    toggleIsShowAllAssetsExpanded: (newValue: boolean) => void
): CalendarModuleCommandBarConfig {
    const getSelectedAssets = lazyGetSelectedAssets.tryImportForRender();
    const boardSelectedAssets = getSelectedAssets ? getSelectedAssets() : [];
    const selectedAssetCount = boardSelectedAssets?.length;

    let primaryItems = [getGoToTodayMenuItem()];

    const assetRegistry = ASSET_REGISTRY.tryImportForRender();
    const boardMenuAssets = assetRegistry?.menuAssets;

    const createAssetMenuItem = boardMenuAssets
        ? getCreateAssetMenuItem(boardMenuAssets, {
              isShowAllAssetsExpanded: isShowAllAssetsExpanded,
              onShowAllAssetsToggled: (
                  event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
              ) => {
                  if (event) {
                      event.preventDefault();
                      toggleIsShowAllAssetsExpanded(!isShowAllAssetsExpanded);
                  }
              },
          })
        : null;

    if (createAssetMenuItem) {
        primaryItems.push(createAssetMenuItem);
    }

    if (selectedAssetCount > 0) {
        primaryItems.push(
            ...getAssetCommandItems(boardSelectedAssets),
            getClearSelectionMenuItem()
        );
    }

    return {
        primaryItems,
        farItems: [getViewSwitcherMenuItem(onCustomRenderSubMenuChange)],
    };
}
